module.exports = __webpack_public_path__ + "static/media/job-03.07d8038d.jpg";